import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    saveConfigurationGotVehicleCode,
    saveConfigurationRedirect,
    startSaveConfiguration,
} from '../../actions/app/saveConfiguration.actions'
import { createVehicleCode, setVehicleCodeState } from '../../actions/app/vehicleCode.actions'
import saveUrlSelector from '../../selectors/url/saveUrlSelector'

const saveConfigurationMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)
    const { dispatch, getState } = store

    if (isActionOf(startSaveConfiguration, action)) {
        dispatch(createVehicleCode(undefined, {
            onSuccess: saveConfigurationGotVehicleCode,
        }))
    }

    if (isActionOf(saveConfigurationGotVehicleCode, action)) {
        const { vehicleCode } = action.payload

        dispatch(setVehicleCodeState(vehicleCode))
        dispatch(saveConfigurationRedirect())
    }

    if (isActionOf(saveConfigurationRedirect, action)) {
        const state = getState()
        const saveUrl = saveUrlSelector(state)

        if (saveUrl) {
            window.location.href = saveUrl
        } else {
            console.warn('saveConfigurationMiddleware: saveUrl is not defined, skipping redirect')
        }
    }
}

export default saveConfigurationMiddleware
